import StorageProvider from "../StorageProvider.web";
import { AUTH_TOKEN_KEY } from "./sessionConfig";

export async function storeAuthToken(token: string): Promise<void> {
  await StorageProvider.set(AUTH_TOKEN_KEY, token);
}

export async function clearSession(): Promise<void> {
  await StorageProvider.clearStorage();
  localStorage.clear();
}
